<div class="h-full w-full">
    <div class="hidden lg:flex flex-wrap justify-between border-gray-200 tab-parent">
        <div
            *ngFor="let tab of tabs; let i = index"
            (click)="selectTab(i)"
            [class.brand-text]="selectedTab === i"
            [class.font-bold]="selectedTab === i"
            [class.border-bottom]="selectedTab === i"
            class="p-3 w-full lg:w-[33%] text-center tabs cursor-pointer hover:bg-blue-100"
        >
            {{ tab.label }}
        </div>
    </div>

    <!-- Accordion View for Mobile -->
    <div class="lg:hidden">
        <div *ngFor="let tab of tabs; let i = index" class="border-b">
            <div
                (click)="toggleAccordion(i)"
                class="p-3 w-full text-center cursor-pointer flex justify-between items-center"
            >
                <span class="font-semibold">{{ tab.label }}</span>
                <span [class.rotate-180]="accordionOpen === i" class="transition-transform">
                    ▼
                </span>
            </div>
            <div *ngIf="accordionOpen === i" class="p-4 border-t">
                <p class="text-lg font-semibold brand-text">{{ tab.label }}</p>
                <p class="my-4 text-gray-600">{{ tab.content }}</p>
                <img [src]="tab.image" alt="" class="h-full">
            </div>
        </div>
    </div>

    <!-- Tab Content for Desktop View -->
    <div class="p-5 border hidden lg:block">
        <ng-container *ngIf="selectedTab !== null">
            <p class="text-lg font-semibold brand-text">{{ tabs[selectedTab].label }}</p>
            <p class="my-4 text-gray-600">{{ tabs[selectedTab].content }}</p>
            <div>
                <img [src]="tabs[selectedTab].image" alt="" class="h-full">
            </div>
        </ng-container>
    </div>
</div>
